import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const RESTOCK_STORE_TARGET_KIND = "restockStore";

export const RESTOCK_LOCATIONS_DOCK_PAGE_ID = "data-management-locations";

export const LOCATIONS_PATH = "/restock/data-management/locations";

const RESTOCK_STORE_ROUTE_PATTERN = /^\/restock\/data-management\/locations\/([^/?#]+)$/;

export const matchRestockStoreReceiverRoute = (pathname: string): ContinuationTarget | null => {
	const match = RESTOCK_STORE_ROUTE_PATTERN.exec(pathname);
	if (!match) return null;
	try {
		return { targetId: decodeURIComponent(match[1]), targetKind: RESTOCK_STORE_TARGET_KIND };
	} catch {
		return null;
	}
};

const restockStoreReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: ({ targetId }) => `${LOCATIONS_PATH}/${encodeURIComponent(targetId)}`,
	matchesRoute: matchRestockStoreReceiverRoute
};

export default restockStoreReceiverIdentityAdapter;
